import { useReducer } from 'react';

// useful for showing dialogs, toggle states, etc
const useToggleReducer = (initailState = false) =>
  useReducer(toggle => !toggle, initailState);

export default useToggleReducer;
